 

<ng-container *ngIf="data.question">
  
    <div class="chat-list-row" id="question{{data?.sequence_id}}">
  
        <div class="question" >
              {{data?.question}}   
        </div> 
       
      </div>
 </ng-container>
 <ng-container *ngIf="showPaginateSpinner">
  <div class="chat-list-row" style="flex-direction: row;justify-content: center;">
  <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
</div>
 </ng-container>
 <ng-container *ngIf="!showPaginateSpinner">
    <ng-container *ngIf="data.bot_answer">
        <div class="chat-list-row">
   
            <div class="answer">
    
             
     
               <div class="answer-content" [innerHTML]="changeNewLine(data.bot_answer)"></div>  
              
               
               </div> 
              
                
           
           <!-- <div class="answer-header">
          
            <span class="menu-list">
              
              <ul>
                <li (click)="refresh()" class="has-tooltip-top"  data-tooltip="Refresh" placement="top"><i class="fa fa-refresh"  aria-hidden="true"></i></li>
                <li class="has-tooltip-top"  data-tooltip="Audio" placement="top">
                  <app-toggle-icon [icons]="volumeicons" [defaultState]="'off'" (iconState)="speakText($event,data.bot_answer)"></app-toggle-icon>
                </li>
                <li (click)="generateAudio()" class="has-tooltip-top"  data-tooltip="Audio File" placement="top"><i class="fa fa-file-audio-o" aria-hidden="true"></i></li>
             
                <li>
                 <div class="dropdown is-hoverable">
                  <div class="dropdown-trigger" class="has-tooltip-top"  data-tooltip="Pin" placement="top"><i class="fa fa-thumb-tack" aria-hidden="true"></i></div>
                  <div class="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                      <div class="dropdown-item">
                        <li (click)="PingedChat(index)">Create a new pin</li>
                        <li>Add to existing pin</li>
          
                      </div>
                    </div>
                  </div> 
                  </div> 
                </li>
                <li (click)="openDialog()" class="has-tooltip-top"  data-tooltip="Create Document" placement="top"><i class="fa fa-file-text-o" aria-hidden="true"></i></li>
             
                <li (click)="copiedText(index)" class="has-tooltip-top"  data-tooltip="Copy Text" placement="top"><i class="fa fa-files-o" aria-hidden="true"></i></li>
           
              </ul>
            </span>
            </div> -->
          </div> 
           <div style="display: flex;
           flex-direction: row;
           justify-content: flex-end; margin-bottom:30px;
           ">
            <span> {{data?.created_at | date:'MMM d, y, h:mm a' }}</span>
           </div>
         
 
    
      </ng-container>
      
 </ng-container>
 
 

 

 